(function ($){
    $(document).ready(function (){
    
     //Color Swatches
      $(".color-swatch").hover(
  function() {
    $('.product_card__image-wrapper[data-variant-id='+$( this ).data('variant-id')+'], .product_card__image-wrapper[data-variant-id='+$( this ).data('variant-id')+'] .product_card__image').css('opacity', '1');
  }, function() {
    $('.product_card__image-wrapper[data-variant-id='+$( this ).data('variant-id')+'], .product_card__image-wrapper[data-variant-id='+$( this ).data('variant-id')+'] .product_card__image').css('opacity', '0');
  	$('.product_card__image-wrapper[data-variant-id='+$( this ).data('variant-id')+']').parents('.product').find($(".product_card__image-wrapper")).first().css("opacity", "1");
  	$('.product_card__image-wrapper[data-variant-id='+$( this ).data('variant-id')+']').parents('.product').find($(".product_card__image-wrapper .product_card__image")).first().css("opacity", "1");
  }
);

    });
})(jQuery);